export default __webpack_public_path__ + "static/media/bike3.f221e417.jpg";